// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-details-order-status-stepper .col{background-color:#f6f6f6;height:90px}.order-details-order-status-stepper .col p{color:#595959!important}.order-details-order-status-stepper .active-col{background-color:transparent}.order-details-order-status-stepper .active-col p{color:#000!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
